import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile, UploadFilter } from 'ng-zorro-antd/upload';
import { Observable, Observer, Subscription } from 'rxjs';
import {TaskService} from '../../services/task.service';
import { NgxPermissionsService } from 'ngx-permissions';
import 'quill-mention';
import {HttpClient} from '@angular/common/http';
@Component({
  selector: 'nf-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.css'],
  providers: [TaskService]
})
export class ConversationComponent implements OnInit, OnDestroy {
  dataSubscription: Subscription = null;
  hashValues = [];
  atValues = [];
  // hashValues = [
  //   { id: 3, value: '话题1' },
  //   { id: 4, value: '话题2' }
  // ];
  quillConfig = {};
  @Input('nfData') set changePath(data: any) {
    if (JSON.stringify(data) !== '{}') {
      console.log(data)
      this.tabIndex = 0;
      this.boardId = data.boardId;
      this.pulseData = data.pulse;
      this.columnData = data.column;
      this.logPageIndex = 1;
      this.permissionDefinition = data.permissionDefinition;
      for (const key in this.pulseData.columnValues) {
        if (this.pulseData.columnValues.hasOwnProperty(key)) {
          if (key === this.columnData.id) {
            this.pulseTitle = this.pulseData.columnValues[key];
          }
        }
      }
      // 重置编辑器内容
      this.editorContent = null;
      this.isEditState = false;
      // 获取列表
      this.panelHeight = document.body.clientHeight - 130;
      this.getPostList();
      this.getLogList();
      this.getBoardSubscribersData();
      this.currentUser = data.currentUser;
      this.permissionsService.loadPermissions(this.currentUser.permissions);
    }
  }
  @Input('boardData') set boardDataChange(data) {
    if (data && data.boardData) {
      this.boardColumnData = data.boardData.columns || [];
    }
  }
  boardColumnData = []; // 存放面板列数据
  pulseData: any = {}; // 存放当前行数据
  columnData: any = {}; // 存放当前列数据
  boardId = null; // 面板ID
  pulseTitle = ''; // 当前单元格标题
  panelHeight = 400; // 面板默认高度
  editorContent: any = ''; // 存放编辑器内容
  isEditState = false; // 是否编辑状态
  uploadFileList = []; // 存放上传文件
  postData = []; // 存放评论数据
  replyId = null; // 当前回复Id
  replyValue = ''; // 存放回复内容
  isReplyLoading = false; // 回复按钮状态
  isPostLoading = false; // 评论按钮
  logData: Array<any> = []; // 存放日志数据
  replyTotal: number;
  replyPageSize = 10;
  replyPageIndex = 1;
  logPageSize = 10;
  logTotal: number;
  logPageIndex = 1;
  permissionDefinition: any;
  currentUser: any; // 存放当前用户信息
  tabIndex = 0; // 当前激活tab
  // 上传过滤
  uploadFilters: UploadFilter[] = [
    {
      name: 'type',
      fn: (fileList: NzUploadFile[]) => {
        const filterFiles = fileList.filter(w => ~['image/png'].indexOf(w.type));
        if (filterFiles.length !== fileList.length) {
          this.msg.error(`包含文件格式不正确，只支持 png 格式`);
          return filterFiles;
        }
        return fileList;
      }
    },
    {
      name: 'async',
      fn: (fileList: NzUploadFile[]) => {
        return new Observable((observer: Observer<NzUploadFile[]>) => {
          // doing
          observer.next(fileList);
          observer.complete();
        });
      }
    }
  ];
  uploadFileUrl;
  downloadFileUrl;
  fileType = ['image/jpeg', 'image/png'];
  constructor(
    private msg: NzMessageService,
    private taskService: TaskService,
    private httpClient: HttpClient,
    private permissionsService: NgxPermissionsService,
  ) { }
  ngOnInit() {
    let prefix = this.taskService.getPrefix();
    this.uploadFileUrl = prefix + '/v1/files/upload';
    this.downloadFileUrl = prefix + '/v1/files/downloads/';
    this.initEditorOption();
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription = null;
    }
  }
  // 编辑器配置
  initEditorOption() {
    this.quillConfig = {
      syntax: true,
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link'],
        ['clean']
      ],
      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ['@', '#'],
        source: (searchTerm, renderList, mentionChar) => {
          let values;
          if (mentionChar === '@') {
            values = this.atValues;
          } else {
            values = this.hashValues;
          }
          if (searchTerm.length === 0) {
            renderList(values, searchTerm);
          } else {
            const matches = [];
            for (let i = 0; i < values.length; i++) {
              if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            }
          }
        }
      }
    };
  }
  // 切换编辑器显示状态
  changeEditState() {
    this.isEditState = true;
  }
  created(editor) {
    const range = editor.getSelection(true);
    editor.insertEmbed(range.index, 'text', '');
    if (editor) {
      // 处理从剪切板复制的图片
      editor.root.addEventListener('paste', evt => {
        if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
          evt.preventDefault();
          [].forEach.call(evt.clipboardData.files, file => {
            if (!this.fileType.includes(file.type)) {
              this.msg.warning('请选择格式正确的文件，如：jpg、jpeg、png等');
              return;
            }
            let formData = new FormData();
            formData.append('file', file, file.name);
            this.httpClient.post(this.uploadFileUrl, formData).subscribe(res => {
              try {
                let range = editor.selection.savedRange;
                //  在当前光标位置插入图片
                editor.insertEmbed(range.index, 'image', this.downloadFileUrl + res['id']);
                //  将光标移动到图片后面
                editor.setSelection(range.index + 1);
              } catch (e) {
                console.log('插入图片异常', e);
              }
            });
          });
        }
      });
    }
  }
  tabIndexChange(i) {
    if (i == 0) {
      this.getPostList();
    }
  }
  // 获取评论列表
  getPostList() {
    this.postData = [];
    const params = {
      'page': this.replyPageIndex,
      'size': this.replyPageSize
    };
    this.taskService.getPosts(this.pulseData.id, params).subscribe((res: any) => {
      if (res) {
        this.postData = [];
        const data = res;
        this.replyTotal = data.page.totalElements;
        this.replyPageSize = data.page.size;
        this.replyPageIndex = data.page.number === 0 ? 1 : data.page.number;
        // 组装渲染数据
        for (const key in data.posts) {
          if (data.posts.hasOwnProperty(key)) {
            let obj = {};
            if (data.posts[key].replies) {
              const reply = [];
              for (const k in data.posts[key].replies) {
                if (data.posts[key].replies.hasOwnProperty(k)) {
                  const o = {
                    'id': k,
                    'body': data.posts[key].replies[k].body,
                    'item': data.posts[key].replies[k].item,
                    'replies': data.posts[key].replies[k].replies,
                    'users': data.posts[key].replies[k].users,
                    'createTime': data.posts[key].replies[k].createAt
                  };
                  reply.push(o);
                }
              }
              obj = {
                'id': key,
                'body': data.posts[key].body,
                'item': data.posts[key].item,
                'fromInfoBox': data.posts[key].fromInfoBox,
                'replies': reply,
                'users': data.posts[key].users,
                'createTime': data.posts[key].createAt
              };
            } else {
              obj = {
                'id': key,
                'body': data.posts[key].body,
                'item': data.posts[key].item,
                'fromInfoBox': data.posts[key].fromInfoBox,
                'infoBoxTitle': data.posts[key].infoBoxTitle,
                'replies': data.posts[key].replies,
                'users': data.posts[key].users,
                'createTime': data.posts[key].createAt
              };
            }
            this.postData.push(obj);
          }
        }
        this.taskService.pulsePostReadRecord(this.boardId, this.pulseData.id, this.replyTotal).subscribe(res => {
          if (res) {
            this.pulseData['updatesCount'] = this.replyTotal;
            this.pulseData['updatesReadCount'] = this.replyTotal;
          } else {
            console.log('记录updates阅读数目失败');
          }
        });
      }
    });
  }
  // 提交评论
  sendPost() {
    if (!this.editorContent) {
      this.msg.info('请填写对话内容！');
      return;
    }
    const params = {
      'pulseId': this.pulseData.id,
      'body': this.editorContent
    };
    if (!this.editorContent) {
      this.msg.info('请填写对话内容');
      return;
    }
    this.isPostLoading = true;
    this.taskService.addPosts(params).subscribe((res: any) => {
      for (const item in res) {
        if (res.hasOwnProperty(item)) {
          this.postData = [res[item], ...this.postData];
        }
      }
      this.isPostLoading = false;
      this.msg.create('success', '提交成功！');
      this.getPostList();
      this.editorContent = '';
    }, (err) => {
      this.isPostLoading = false;
    });
  }
  // 取消发送
  cancelSend() {
    this.isEditState = false;
  }
  // 取消回复
  cancelReplySend() {
    this.replyValue = '';
    this.replyId = null;
  }
  // 删除评论
  removePost(id) {
    this.taskService.doRemovePost(id).subscribe((res: any) => {
      this.msg.create('success', '删除成功！');
      this.postData = this.postData.filter(list => id !== list.id);
    });
  }
  // 删除回复
  removeReplyPost(id) {
    this.taskService.doRemovePost(id).subscribe((res: any) => {
      this.msg.create('success', '删除成功！');
      this.getPostList();
    });
  }
  // 开启回复
  openReplay(id) {
    this.replyId = id;
  }
  // 回复评论
  replayPost(id) {
    const params = {
      'body': this.replyValue,
    };
    this.isReplyLoading = true;
    this.taskService.doReplayPost(id, params).subscribe((res: any) => {
      this.isReplyLoading = false;
      this.msg.create('success', '回复成功！');
      this.replyValue = '';
      this.getPostList();
    }, (err) => {
      this.isReplyLoading = false;
    });
  }
  openFileModal() {
    document.getElementById('uploadFile').click();
  }
  beforeUpload = (file: NzUploadFile, fileList: NzUploadFile[]): boolean | Observable<boolean> => {
    if (file && this.fileType.includes(file.type)) {
      return true;
    }
    this.msg.warning('请选择格式正确的文件，如：jpg、jpeg、png等');
    return false;
  }
  uploadFile(event) {
    if (event && event.type === 'success') {
      if (event.file && event.file.response) {
        const token = localStorage.getItem('id');
        const img = '<img class="camera" src="' + this.downloadFileUrl + event.file.response['id'] + '?jtoken=' + token  + '" alt="                                              ">';
        if (this.editorContent) {
          this.editorContent += img;
        } else {
          this.editorContent = img;
        }
      }
    }
  }
  // 获取日志列表
  getLogList() {
    this.logData = [];
    const params = {
      'page': this.logPageIndex,
      'size': this.logPageSize
    };
    this.taskService.getLogData(this.pulseData.id, params).subscribe((res: any) => {
      if (res) {
        this.logData = res.data;
        this.logTotal = res.page.totalElements;
        this.logPageSize = res.page.size;
        this.logPageIndex = res.page.number === 0 ? 1 : res.page.number;
      }
    });
  }
  // 分页切换交互
  replyPageChange(event) {
    this.replyPageIndex = event;
    this.getPostList();
  }
  logPageChange(event) {
    this.logPageIndex = event;
    this.getLogList();
  }
  translateStatus(item, value) {
    const column = this.getColumn(item['columnId']);
    if (value && column) {
      for (let label of column.labels) {
        if (label.index == value.index) {
          return label;
        }
      }
      return {color: '', label: ''};
    } else {
      return {color: '', label: ''};
    }
  }

  getStatusText(item, value) {
    const label = this.translateStatus(item, value);
    if (!label.label) {
      return '-';
    }
    return label['label'];
  }

  getStatusColor(item, value) {
    const label = this.translateStatus(item, value);
    if (!label.label) {
      return 'rgb(255,255,255)';
    }
    return label['color'];
  }

  translateDropdown(item, value) {
    const column = this.getColumn(item['columnId']);
    if (value && value !== 'null' && column && column.settings && column.settings.labels) {
      const result = [];
      if (value.ids) {
        for (const label of column.settings.labels) {
          if (value.ids.includes(label.id)) {
            result.push(label.name);
          }
        }
      }
      return result.join('、');
    } else {
      return '';
    }
  }

  translateSelect(item, value) {
    const column = this.getColumn(item['columnId']);
    if (value && value.option && column && column.config && column.config.option) {
      for (const option of column.config.option) {
        if (value.option === option.id) {
          return option.title;
        }
      }
      return '';
    } else {
      return '';
    }
  }

  translateButton(item, value) {
    const column = this.getColumn(item['columnId']);
    if (value && value.original && column && column.config && column.config.original) {
      for (const option of column.config.original) {
        if (value.original === option.id) {
          return option.title;
        }
      }
      return '';
    } else {
      return '';
    }
  }

  getColumn(id) {
    if (this.boardColumnData) {
      for (let column of this.boardColumnData) {
        if (column['id'] === id) {
          return column;
        }
      }
    }
  }
  // 获取面板成员数据
  getBoardSubscribersData() {
    const param = {
      size: 500
    };
    this.taskService.getBoardSubscribers(this.boardId, param).subscribe((res: any) => {
      if (res.data) {
        res.data.forEach(item => {
          item['value'] = item.name;
          item['denotationChar'] = item.id;
        });
        this.atValues = res.data;
      }
    });
  }
}
